module.exports = __webpack_public_path__ + "static/media/calender.4c006479.svg";